// Display currencies a user can pick (preferences, price conversion). Prices are stored in AED.
export const PREFERRED_CURRENCIES = ['AED', 'USD', 'EUR', 'GBP'] as const;
export type PreferredCurrency = (typeof PREFERRED_CURRENCIES)[number];

export const isPreferredCurrency = (value: unknown): value is PreferredCurrency =>
  typeof value === 'string' && (PREFERRED_CURRENCIES as readonly string[]).includes(value);

// Approximate display-only rates (from → to); never used for charging.
export const EXCHANGE_RATES: Record<PreferredCurrency, Partial<Record<PreferredCurrency, number>>> = {
  AED: { USD: 0.27, EUR: 0.25, GBP: 0.2 },
  USD: { AED: 3.67, EUR: 0.92, GBP: 0.75 },
  EUR: { AED: 4.0, USD: 1.09, GBP: 0.85 },
  GBP: { AED: 4.93, USD: 1.34, EUR: 1.17 },
};
